export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f439bdb6aa7d0cebaae5bf10fa0dad49391e05b85&name=fetchTypeahead!'